import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { StructuredProcessData, StructuredProcessInstance } from './strcutredProcess-data';

@Injectable({ providedIn: 'root' })
export class StructuredProcessStateService {
  processData$ = new BehaviorSubject<StructuredProcessData | null>(null);
  processInstance$ = new BehaviorSubject<StructuredProcessInstance | null>(null);
  currentStageId$ = new BehaviorSubject<string>('');
  currentStepId$ = new BehaviorSubject<string>('');
  isProcessActive$ = new BehaviorSubject<boolean>(false);
  isB2C$ = new BehaviorSubject<boolean>(false);
  showCVUpload$ = new BehaviorSubject<boolean>(false);
  isArtifactViewAvailable$ = new BehaviorSubject<boolean>(false);
  isGeneratingArtifact$ = new BehaviorSubject<boolean>(false);
  isPresentingArtifactView$ = new BehaviorSubject<boolean>(false);

  // Sidebar → process view communication
  pendingStepId: string | null = null;
  stepSelected$ = new Subject<string>();
  restartStep$ = new Subject<string>();
  resetProcess$ = new Subject<void>();
  cvUploadClicked$ = new Subject<void>();
  switchToArtifactClicked$ = new Subject<void>();

  // Process view → sidebar: force expand a stage
  forceStageExpand$ = new Subject<string>();
}
